enum DecisionStatus {
  pass = 'pass',
  fail = 'fail',
  stepUp = 'step_up',
  none = 'none',
}

export default DecisionStatus;
